import { CSSProperties } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// Set on route as pendingComponent with pendingMS 0 to keep sidebar around while any loader queries are running
// Made as a shared component in case we'd like page loading to be more than just a mui loading circle
export function LoadingPageComponent({ isFullScreen }: { isFullScreen?: boolean }) {
  const style: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  };

  if (isFullScreen) {
    style["minHeight"] = "100vh";
  }

  return (
    <div style={style}>
      <CircularProgress variant={"indeterminate"} />
    </div>
  );
}
